<template>
    <div class="tishimain" :class="theme == 1 ? 'white' : 'black'">
        <img src="../assets/Customer.png" alt="" />
        <div v-if="isContract == 1" class="fs32 text" style="color:#86909C;width: 6rem;margin-bottom: 0.48rem;">
            根据证监会相关规定，<span class="color:#1D2129">不得为70周岁及以上（包括服务期内到达70周岁）</span>的客户提供投资咨询服务，如有疑问可联系客服人员</div>
        <div v-else class="fs32 text" style="color:#86909C;width: 6rem;margin-bottom: 0.94rem;">根据证监会相关规定，<span
                class="color:#1D2129">不得为18周岁以下</span>的客户提供投资咨询服务，如有疑问可联系客服人员</div>
        <div class="btn" @click="goProductInfo">我知道了</div>
    </div>
</template>
  
<script>
import {
    connectWebViewJavascriptBridge,
    getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
export default {
    data() {
        return {
            isContract: 1,
            theme: 1
        };
    },
    mounted() {
        var that = this;
        if (userAgent.android) {
            this.$bridge.registermethod("changeTheme", function (responseData) {
                responseData = JSON.parse(responseData);
                that.theme = responseData;
                sessionStorage.setItem("theme", responseData);
            });
        } else {
            connectWebViewJavascriptBridge((bridge) => {
                window.WebViewJavascriptBridge.registerHandler(
                    "changeTheme",
                    function (responseData) {
                        responseData = JSON.parse(responseData);
                        that.theme = responseData;
                        sessionStorage.setItem("theme", responseData);
                    }
                );
            });
        }
    },
    created() {
        this.isContract = this.$route.query.isContract
        if (sessionStorage.getItem("theme") == 2) {
            this.theme = 2;
        } else if (this.$route.query.theme == 2) {
            this.theme = 2;
        } else {
            this.theme = 1;
        }
    },
    methods: {
        next() {
            window.location.href = this.OrderInfo.url
        },
        goProductInfo() {
            var productId = sessionStorage.getItem("productId");
            var type = sessionStorage.getItem("producttype");
            if (productId) {
                var query = { type: type, id: productId, theme: this.theme };

                location.reload();
                setTimeout(() => {
                    this.$router.replace({ path: "/product_info", query: query });
                }, 100);
                let backlen = window.history.length - 1;
                window.history.go(-backlen);
            } else {
                let backlen = window.history.length - 1;
                window.history.go(-backlen);
            }

        },
    },
};
</script>
  
<style lang="less" scoped>
.tishimain {
    display: flex;
    flex-direction: column;
    align-items: center;
}

img {
    width: 3.2rem;
    height: 3.2rem;

}

.text {
    margin-top: 0.48rem;
    color: #86909C;

    span {
        color: #1D2129
    }
}

.btn {
    width: 6.86rem;
    height: 0.96rem;
    background: #F23536;
    border-radius: 0.08rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.32rem;
    color: #ffffff;
}

.black {
    background: #12161f;
    height: 100vh;
    .text {
    color: #C9CDD4;

    span {
        color: #fff
    }
}
}</style>